import JSEncrypt from 'jsencrypt';
import Base64 from './base64';

const encryptStr = new JSEncrypt();
encryptStr.setPublicKey('-----BEGIN PUBLIC KEY-----\n' +
  'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDGgOtNRPcXtYbcpz2MMkxJVg2w\n' +
  'urSY/+TLltLI0mJsG2N3vtzx6J9YjSBpLNyHerLn+LaVTcpsdFGBjkCIP2iyM3jJ\n' +
  'gskBupI4nCHWRItP3Dfj04q5wWDFqBHay9sToKZZkACMIzb8w2FSKR4O3VhpAJas\n' +
  'nxoQMaqa7TqKlSahLwIDAQAB\n' +
  '-----END PUBLIC KEY-----\n'); // 设置 加密公钥

export default {
  params: {},

  //生成请求组合参数rsa
  encode_post_rsa: function() {
    return JSON.stringify({
      params: this.create_data_rsa()
    });
  },
  //创建data数据rsa
  create_data_rsa: function() {
    let _params = {};
    let split_str, _string, isOkay, encode_data = '';
    let keys = Object.keys(this.params);
    keys.sort().map(k => {
      _params[k] = this.params[k];
    });
    _string = Base64.Base64.encode(JSON.stringify(_params));
    split_str = this.str_split(_string, 117);
    for (var part in split_str) {
      isOkay = encryptStr.encrypt(split_str[part]);
      if (!isOkay) {
        return false;
      }
      encode_data += isOkay;
    }
    return encode_data;
  },
  //字符串按长度拆分为数组
  str_split: function(str, n) {
    var strArr = [];
    for (var i = 0, l = str.length; i < l / n; i++) {
      var a = str.slice(n * i, n * (i + 1));
      strArr.push(a);
    }
    return strArr;
  }
};
